import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";

export type ResultadoFechamentoAluno =
  | "aprovado"
  | "reprovado_falta"
  | "reprovado_nota"
  | "pendente";

export interface AlunoFechamentoItem {
  participanteId: number;
  nome: string;
  email: string | null;
  media: number | null;
  percentualFaltas: number | null;
  totalAulas: number;
  faltas: number;
  resultado: ResultadoFechamentoAluno;
  motivoPendente?: string;
  statusDestino: 19 | 20 | null;
}

export interface FechamentoTurmaPreview {
  eventoId: number;
  loginId: number;
  tituloTurma: string;
  notaMinimaAprovacao: number | null;
  percentualMaximoFaltas: number | null;
  podeFechar: boolean;
  jaEncerrada: boolean;
  dataConclusaoAtingida: boolean;
  aprovados: AlunoFechamentoItem[];
  reprovadosFalta: AlunoFechamentoItem[];
  reprovadosNota: AlunoFechamentoItem[];
  pendentes: AlunoFechamentoItem[];
}

export interface FechamentoTurmaResultado {
  eventoId: number;
  aprovados: number;
  reprovadosFalta: number;
  reprovadosNota: number;
  turmaEncerradaEm: string;
}

const ensinoFechamentoBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const { baseQueryWithReauth } = await import("@/lib/api");
  return baseQueryWithReauth(args, api, extraOptions);
};

export const ensinoFechamentoAPI = createApi({
  reducerPath: "ensinoFechamentoAPI",
  baseQuery: ensinoFechamentoBaseQuery,
  tagTypes: ["FechamentoTurma"],
  endpoints: (build) => ({
    getFechamentoPreview: build.query<
      FechamentoTurmaPreview,
      { eventoId: number; loginId: number }
    >({
      query: ({ eventoId, loginId }) => ({
        url: `/ensino/turmas/${eventoId}/fechamento/preview`,
        method: "GET",
        params: { loginId },
      }),
      providesTags: (_r, _e, arg) => [{ type: "FechamentoTurma", id: arg.eventoId }],
    }),
    fecharTurma: build.mutation<
      FechamentoTurmaResultado,
      { eventoId: number; loginId: number }
    >({
      query: ({ eventoId, loginId }) => ({
        url: `/ensino/turmas/${eventoId}/fechamento`,
        method: "POST",
        params: { loginId },
        body: { LoginId: loginId },
      }),
      invalidatesTags: (_r, _e, arg) => [{ type: "FechamentoTurma", id: arg.eventoId }],
    }),
  }),
});

export const {
  useGetFechamentoPreviewQuery,
  useLazyGetFechamentoPreviewQuery,
  useFecharTurmaMutation,
} = ensinoFechamentoAPI;
